import { DELAY_TIME } from "@constants";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { ReactElement } from "react";

interface SHIconTooltipContainerProps {
  tooltipProps?: Omit<TooltipProps, "children">;
  children: ReactElement<any, any>;
  isVisible?: boolean;
}
const SHIconTooltipContainer = ({
  tooltipProps,
  isVisible,
  children,
}: SHIconTooltipContainerProps): JSX.Element => {
  if (!isVisible) return <></>;
  return (
    <Tooltip
      {...tooltipProps}
      title={tooltipProps?.title || ""}
      enterDelay={DELAY_TIME}
      enterNextDelay={DELAY_TIME}
      placement="top"
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
              {
                marginBottom: "5px",
              },
            height: "20px",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default SHIconTooltipContainer;
